const siteList = (state) => state.siteList;
const serviceProviderList = (state) => state.serviceProviderList;
const rateList = (state) => state.rateList;
const siteDetails = (state) => state.siteDetails;



export default {
  siteList,
  siteDetails,
  rateList,
  serviceProviderList,
}


// WEBPACK FOOTER //
// ./src/store/modules/siteManagement/getters.js